import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import Chart from 'react-apexcharts';

const MixedChart = ({ chartProps, ...props }) => {
    const theme = useTheme();
    const [graphState, setGraphState] = useState(updateState(chartProps, theme));
    useEffect(() => {
        setGraphState(updateState(chartProps, theme))
    }, [chartProps, theme])

    return (
        <Chart
            options={graphState.options}
            series={graphState.series}
            type='line'
            width={'98%'}
            height={'93%'}

            style={{width: '100%'}}

        />
    );
}

export default MixedChart;

const updateState = (chartProps, theme) => {
    return {
        series: chartProps.data,
        options: {
            chart: {
                type: 'line',
                stacked: chartProps.stacked ?? false,
                zoom: {
                    enabled: true
                }
            },
            stroke: {
                width: [0, 2, 5],
                curve: 'smooth'
            },
            plotOptions: {
                bar: {
                    columnWidth: '50%'
                }
            },
            colors: theme.chartArray,
            fill: {
                opacity: [0.85, 0.25, 1],
                gradient: {
                    inverseColors: false,
                    shade: 'light',
                    type: 'vertical',
                    opacityFrom: 0.85,
                    opacityTo: 0.55,
                    stops: [0, 100, 100, 100]
                }
            },
            labels: chartProps.xAxis,
            xaxis: {
                labels: {
                    style: {
                        colors: theme.text
                    }
                }
            },
            markers: {
                size: 0
            },
            yaxis: {
                title: {
                    text: chartProps.yAxis,
                    style: {
                        color: theme.text
                    }
                },
                labels: {
                    style: {
                        colors: theme.text
                    }
                }
            },
            legend: {
                position: chartProps.legendPosition ?? 'bottom',
                labels: {
                    colors: theme.text
                }
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: (val) => chartProps.tooltipFormatter ? chartProps.tooltipFormatter(val) : val,
                }
            }
        }
    };
}